module.exports = __webpack_public_path__ + "img/typescript.ff4498ab.svg";